/**
 * DeliverySacPublicRequest
 * @author ftgibran
 */
import {
  IResource,
  Model,
  ResponseFill,
  HttpIgnore,
  ObjectCollection,
  ID, HttpBody, $,
} from 'simpli-web-sdk'
import {ItrackCollection} from '@/helpers'
import moment from 'moment'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import {DeliverySlaStatus} from '@/enums/DeliverySlaStatus'
import RastreamentoDistanciaResponse from '@/model/response/RastreamentoDistanciaResponse'

@HttpIgnore()
export default class DeliverySacPublicRequest extends Model {
  readonly $name: string = 'DeliverySacRequest'

  allDocs = new ObjectCollection()
  allSlaStatus = ItrackCollection.allSlaStatus.prependNull('app.all')
  allStatus = ItrackCollection.allStatus.prependNull('app.all')

  @ResponseFill('token')
  token: string | null = null

  @ResponseFill('danfe')
  danfe: string | null = null

  @ResponseFill('nroFiscal')
  nroFiscal: string | null = null

  @ResponseFill('nroCorreios')
  nroCorreios: string | null = null

  @ResponseFill('nroPedido')
  nroPedido: string | null = null

  @ResponseFill('cte')
  cte: string | null = null

  @ResponseFill('cpfCnpj')
  cpfCnpj: string | null = null

  @ResponseFill('idEmbarcador')
  idEmbarcador: ID | null = null

  @ResponseFill('dataInclusao')
  dataCriacao: string | null = null

  @ResponseFill('login')
  login: string | null = null

  @ResponseFill('senha')
  senha: string | null = null

  @ResponseFill('idCarga')
  idCarga: ID | null = null

  @ResponseFill('idStatusPk')
  status: DeliveryStatus | null = null

  @ResponseFill('slaPendente')
  slaStatus: DeliverySlaStatus | null = null

  @ResponseFill('dataCriacaoIni')
  startDate: string | null = null

  endDate: string | null = null

  @ResponseFill('dataCriacaoFim')
  get end() {
    // we should send the next day to the server, the prop endDate is used only to control what the user input
    return !this.endDate ? this.endDate : moment(this.endDate).add(1, 'day').format()
  }

  set end(val) {
    if (val) {
      // in the way back we need to subtract, so the params in the route dont mess up
      this.endDate = moment(val).subtract(1, 'day').format()
    }
  }

  get docsResource() {
    const str = String(this.nroFiscal || '')
    const docs = str.split(',')
    return this.allDocs.getMany(docs)
  }
  set docsResource(val: IResource[]) {
    this.nroFiscal = val.map((item: IResource) => item.$id).join(',')
  }

  cleanDocs() {
    this.nroFiscal = ''
  }

  populateAllDocs(val: IResource[]) {
    this.allDocs = new ObjectCollection(val)
  }

  get statusResource() {
    return this.allStatus.get(this.status)
  }
  set statusResource(val: IResource | null) {
    this.status = val && val.$id as DeliveryStatus || null
  }

  get slaStatusResource() {
    return this.allSlaStatus.get(this.slaStatus)
  }
  set slaStatusResource(val: IResource | null) {
    this.slaStatus = val && val.$id as DeliverySlaStatus || null
  }

  get isCleared() {
    return !this.danfe
      && !this.nroFiscal
      && !this.nroCorreios
      && !this.nroPedido
      && !this.cte
      && !this.cpfCnpj
      && !this.idEmbarcador
      && !this.idCarga
  }

  clean() {
    this.danfe = null
    this.nroFiscal = null
    this.nroCorreios = null
    this.nroPedido = null
    this.cte = null
    this.cpfCnpj = null
    this.idEmbarcador = null
    this.dataCriacao = null
    this.login = null
    this.senha = null
    this.idCarga = null
  }

  async getRastreamentoDistancia(id: ID, spinner = 'getRastreamentoDistancia') {
    const fetch = async () => {
      return await new HttpBody<RastreamentoDistanciaResponse>(RastreamentoDistanciaResponse)
          .GET(`/user/carga/sac/rastreamento-distancia?idCarga=${id}`)
    }

    return await $.await.run(fetch, spinner, 1000)
  }
}
